import React, { useEffect } from 'react';
import { Typography, Paper, Grid, Card, CardContent } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PeopleIcon from '@mui/icons-material/People';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const DashboardOverview = () => {
  const features = [
    { title: "Real-time Analytics", icon: <BarChartIcon />, description: "Get instant insights into your AI Talker's performance with live data updates." },
    { title: "Call History", icon: <AccessTimeIcon />, description: "Access detailed logs of all AI interactions, including duration and outcomes." },
    { title: "User Engagement", icon: <PeopleIcon />, description: "Track user interactions and satisfaction levels across all AI conversations." },
    { title: "Performance Trends", icon: <TrendingUpIcon />, description: "Visualize long-term trends in AI performance and user engagement." },
  ];

  return (
    <Paper elevation={0}>
      <Typography variant="h4" gutterBottom>Dashboard Overview</Typography>
      <Typography paragraph>
        The AI Talker Dashboard is your central hub for monitoring and managing your AI-powered communication system. 
        It provides a comprehensive view of your AI Talker's performance, user interactions, and key metrics.
      </Typography>
      <Typography variant="h6" gutterBottom>Key Features:</Typography>
      <Grid container spacing={3}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Card>
              <CardContent>
                {feature.icon}
                <Typography variant="h6" component="div">
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default DashboardOverview;
